import Appointment from "Pages/Appointment/Appointment";
import React from "react";
import icons from "../Common/Icons";
import { DashboardMenu, AssessmentMenu, AppointmentMenu, HealthProfileMenu, CareTeamMenu, MyProfileIcon,MyOrderIcon, 
         DocUpload,SubscriptionPlan,MyAvailabilityIcon, MyPatientIcon, AllPatientIcon, CareAdminDashboardMenu,InstructionsMenu, ConsultationsCareadmin, MyTicketIcon, CareadminDoctors, CareadminRecords, ReportsIcon,
          AllTicketIcon, PatientRecordIcon, ConsultationIcon, SettingsMenu , AddMedicine,CouponMenuGray, AnalysticsIcon,ProfileMenu} from "Common/ReactIcons";
const MyAvailabilityNewVersion = React.lazy(() => import(("Pages/MyProfile/MyAvailabilityNewVersion")));
const MedicineList = React.lazy(() => import(("Pages/Prescription/MedicineList")));
const ManageCoupon = React.lazy(() => import(("Pages/Prescription/ManageCoupon")));
const LanguageSelect = React.lazy(() => import(("Pages/Authentication/Funneling Questions/LanguageSelect")));
import Gatekeeper from "Gatekeeper";
import AppointmentConfirmation from "Pages/Appointment/AppointmentConfirmation";
import DynamicLinking from "Pages/Authentication/DynamicLinking";
import PaymentSuccess from "Pages/Assessment/PaidAssessment/PaymentSuccess";
import PaymentViewAssessment from "Pages/Payment/PaymentViewAssessment";
import DementiaAssessmentLinking from "Pages/Assessment/DementiaAssessmentLinking";
import TermsPage from "Pages/MyProfile/TermsPage";
import PrivacyPolicyPage from "Pages/MyProfile/PrivacyPolicyPage";
import MemCheck from "Pages/Assessment/MemCheck";
import CorporateDashboardDummy from "Pages/CoOrperateAdmin/CorporateDashboardDummy";
import CorporateTableDummy from "Pages/CoOrperateAdmin/CorporateTableDummy";
import CorporatePersonInfo from "Pages/CoOrperateAdmin/CorporatePersonInfo";
const SignUpPage = React.lazy(() => import(("Pages/Authentication/Signup")));
const Login = React.lazy(() => import(("Pages/Authentication/Login")));
import { Redirect } from "react-router-dom";
const GetStarted = React.lazy(() => import ("Pages/Authentication/GetStarted"));
const GenderSignUpCheck  = React.lazy(() => import("Pages/Authentication/GenderSignUpCheck"));
const AgeRestriction = React.lazy(() => import ("Pages/Authentication/AgeRestriction"));
const ForgotPassword = React.lazy(() => import("Pages/Authentication/ForgotPassword"));
const OTPInput = React.lazy(() => import("Pages/Authentication/OTPInput"));
const CareAdminIntro = React.lazy(() => import("Pages/Patient/PatientFirstTimeLogin/CareAdminIntro"));
const Landing = React.lazy(() => import("Pages/LandingPage/Landing"));
const Assessment = React.lazy(() => import("Pages/Assessment/Assessment"));
const ChoosePreferredClinician = React.lazy(() => import("Pages/Patient/PatientFirstTimeLogin/ChoosePreferredClinician"));
const DoctorWelcome = React.lazy(() => import("Pages/Patient/PatientFirstTimeLogin/DoctorWelcome"));
const SelectedPreferredClinician = React.lazy(() => import("Pages/Patient/PatientFirstTimeLogin/SelectedPreferredClinician"));
const B2bFirstLogin = React.lazy(() => import("Pages/Authentication/B2BFirstLogin"));
const FirstTimeLogin = React.lazy(() => import("Pages/Authentication/FirstTimeLogin"));
const SetPasswardScreen = React.lazy(() => import("Pages/Authentication/SetPassword"));
const OTPDeleteInput =React.lazy(() => import("Pages/Authentication/OTPDeleteInput"));

const GuestUserAuth = React.lazy(() =>
  import("Pages/LandingPage/GuestUserAuth")
);
const MyAppointment = React.lazy(() =>
  import("Pages/Appointment/MyAppointment")
);
const AssessmentHistory = React.lazy(() =>
  import("Pages/Assessment/AssessmentHistory")
);
const PaymentDetail = React.lazy(() =>
  import ("Pages/Assessment/PaidAssessment/PaymentDetail")
);
const ConsultationHistory = React.lazy(() =>
  import("Pages/Consultation/ConsultationHistory")
);
const MyPatient = React.lazy(() => import("Pages/Patient/MyPatientHome"));
const MyAllPatient = React.lazy(() => import("Pages/Patient/MyAllPatients"));
const MyPatientDetail = React.lazy(() => import("Pages/Patient/MyPatient"));
const PHISummary = React.lazy(() => import("Pages/PHI/PHISummary"));
const ShortendForm = React.lazy(() => import("Pages/PHI/ShortHandForm/ShortHandForm"));
const NewHealthProfile = React.lazy(()=> import("Pages/PHI/ShortHandForm/NewHealthProfile"))
const Dashboard = React.lazy(() => import("Pages/Dashboard/Dashboard"));
const ScheduleAppointment = React.lazy(() =>
  import("Pages/Appointment/ScheduleAppointment")
);
const MyAvailability = React.lazy(() =>
  import("Pages/MyProfile/MyAvailability")
);

const B2BcareTeamAssigned = React.lazy(() =>
  import("Pages/Authentication/Funneling Questions/B2BCareTeamAssigned")
);

const MyProfile = React.lazy(() => import("Pages/MyProfile/MyProfile"));
const MyProfileChild = React.lazy(() => import("Pages/MyProfile/MyProfileChild"));
const AssessmentType = React.lazy(() => import("Pages/Assessment/SelectAssessmentType"));
const AssessmentScoreDetails = React.lazy(() => import("Pages/Assessment/AssessmentScoreDetails"));
const BookAppointment = React.lazy(() => import("Pages/Appointment/BookAppointment"));
const PatientDetail = React.lazy(() => import("Pages/Patient/PatientDetail"));
const CareAdmin = React.lazy(() => import("Pages/CareAdmin/CareAdmin"));
const TicketList = React.lazy(() => import("Pages/CareAdmin/TicketList"));
const SearchPatient = React.lazy(() => import("Pages/CareAdmin/SearchPatient"));
const PatientLists = React.lazy(() => import("Pages/CareAdmin/PatientLists"));
const PlanWise = React.lazy(()=> import("Pages/CareAdmin/PlanWiseStatistics"));
const PlanHistory = React.lazy(()=> import("Pages/CareAdmin/PlanHistory"));
const NewSelectAssessmentType = React.lazy(()=> import("Pages/Assessment/NewSelectAssessmentType"));
const PathwayProcess = React.lazy(() => import("Pages/Authentication/Funneling Questions/PathwayProcess"));


const VideoConsultation = React.lazy(() =>
  import("Pages/Consultation/VideoConsultation")
);
const PatientRecord = React.lazy(() => import("Pages/CareAdmin/PatientRecord"));
const PatientConsultation = React.lazy(() => import("Pages/CareAdmin/ConsultationHistory"));
const ConsultationList = React.lazy(() =>
  import("Pages/CareAdmin/ConsultationList")
);
const MyTickets = React.lazy(() => import("Pages/CareAdmin/MyTickets"));
const B2BRecords = React.lazy(() => import("Pages/CareAdmin/B2Brecords"))
const AnalyticsIframe = React.lazy(() => import("Pages/CareAdmin/Analytics"))
const PaymentView = React.lazy(() => import("Pages/Payment/PaymentViewThirdVersion"));
// const PaymentView = React.lazy(() => import("Pages/Payment/PaymentViewSecondVersion"));
const Subscription = React.lazy(() => import("Pages/Payment/Subscription"));
const Coupon = React.lazy(() => import("Pages/Payment/Coupon"));
const CareChatPage = React.lazy(() => import("Pages/Chat/CareChatPage"));
const CareAdminDomainDashboard = React.lazy(() =>
  import("Pages/CareAdmin/CareAdminDomainDashboard")
);
const SuperAdmin = React.lazy(() => import("Pages/SuperAdmin/SuperAdminRole"));
const AddService = React.lazy(() => import("Pages/SuperAdmin/AddService"));
const Authentication = React.lazy(() => import("Pages/Authentication/Authentication"));
const SwitchAccount = React.lazy(() => import("Pages/Authentication/SwitchAccount"));
const CorporateDashboard = React.lazy(() => import("Pages/CoOrperateAdmin/CorporateDashboard"))
const CorporateDashboardNew = React.lazy(() => import("Pages/CoOrperateAdmin/CorporateDashboardNew"))
const CorporateTable = React.lazy(() => import("Pages/CoOrperateAdmin/CorporateTable"))
const UploadFile = React.lazy(() => import("Pages/CoOrperateAdmin/UploadFile"))
const AccountProfiles = React.lazy(() => import("Pages/Authentication/AccountProfiles"))
const RoleSelection = React.lazy(() => import("Pages/Authentication/RoleSelection"))
const PrivacyPolicy = React.lazy(() => import("Pages/Others/PrivacyPolicy"))
const TermsofUse = React.lazy(() => import("Pages/Others/TermsofUse"))
const MyOrders = React.lazy(() => import("Pages/Payment/MyOrders"))
const MedicalDocument = React.lazy(() => import ("Pages/Patient/MedicalDocument"))
const FunnelingQuestions = React.lazy(()=>import("Pages/Authentication/Funneling Questions/FunnelingQuestions"))
const DoctorFollowUpTickets = React.lazy(()=>import ("Pages/Others/DoctorFollowUpTicket"))
const PlanProcess = React.lazy(()=>import("Pages/PlanProcess/PlanProcess"))
const BeginAssessment = React.lazy(()=>import("Pages/Patient/PatientFirstTimeLogin/BeginAssessment"));
export const LoggedUserRoutes = [
  {
    path: "/dashboard",
    icon: <DashboardMenu />,
    showmenu: true,
    label: "Dashboard",
    value: "dashboard",
    render: (props) => <Gatekeeper><Dashboard {...props} /></Gatekeeper> ,
  },
  {
    path: "/video-consultation",
    render: (props) => (<VideoConsultation {...props} />),
  },
  {
    path: "/assessment",
    label:"Assessment",
    value: "assessment",
    icon: <AssessmentMenu />,
    showmenu: true,
    render: (props) => <NewSelectAssessmentType {...props}/>,
  },
  {
    path: "/health-profile",
    icon:<HealthProfileMenu/>,
    showmenu: true,
    label: "Health Record",
    value: "health-profile",
    render: (props) => <NewHealthProfile {...props} />,
  },  
  {
    path: "/document-upload",
    icon: <DocUpload />,
    showmenu: true,
    label: "File Upload",
    value: "document-upload",
    render: (props) => <MedicalDocument {...props} />,
  }, 
  {
    path: "/preferred-clinician",
    icon: <CareTeamMenu/>,
    showmenu: true,
    label: "Care Team",
    value: "preferred-clinician",
    render: (props) => <ChoosePreferredClinician {...props} />,
  },
  {
    path: "/schedule-appointment",
    render: (props) => <Appointment {...props} />,
  },
  {
    icon:<AppointmentMenu />,
    showmenu: true,
    path: "/consultation-history",
    label: "Appointment",
    value: "consultation-history",
    render: (props) => <ConsultationHistory {...props} />,
  }, 
  {
    path: "/select-assessment",
    render: (props) => <AssessmentType {...props} />,
  },
  {
    path: "/assessment",
    render: (props) => <NewSelectAssessmentType {...props} />,
  },
  {
    path: "/detailed-health-profile",
    render: (props) => <PHISummary {...props} />,
  },
  {
    path: "/take-assessment",
    render: (props) => <Assessment {...props} />,
  },
  {
    path: "/score-details",
    value: "score-details",
    render: (props) => <AssessmentScoreDetails {...props} />,
  },
  {
    path: "/payment-detail",
    render: (props) => <PaymentDetail {...props} />,
  },
  {
    path: "/payment-success",
    render: (props) => <PaymentSuccess {...props} />,
  },
  {
    path: "/select-doctor",
    render: (props) => <BookAppointment {...props} />,
  },
  {
    path: "/paymentView",
    render: (props) => <PaymentView {...props} />,
  },
  {
    path: "/assessmentPaymentView",
    render: (props) => <PaymentViewAssessment {...props} />,
  },
  {
    path: "/my-account",
    render: (props) => <MyProfile {...props} />,
  },
  {
    path:"/pathway-process",
    render:(props) => <Gatekeeper {...props}><PathwayProcess {...props}/></Gatekeeper>
  },
  {
    path: "/select-language",
    render: (props) =><Gatekeeper {...props}><LanguageSelect {...props}/></Gatekeeper>,
  },
  {
    path: "/select-your-plan",
    // Care Pathways is no longer an onboarding step (profile_status v2.0.0); the dashboard's Gatekeeper
    // sends an unfinished onboarding to its next step, and everyone else lands on the dashboard
    render: () => <Redirect to={{ pathname: "/logged-in-user/dashboard" }} />,
  },
  {
    path: "/doctor-detail",
    render: (props) => <DoctorWelcome {...props} />,
  },
  {
    path: "/preferred-clinician",
    render: (props) =><Gatekeeper  {...props}> <ChoosePreferredClinician {...props} /></Gatekeeper>,
  },
  {
    path: "/b2bcare-team-assignment",
    render: (props) => <B2BcareTeamAssigned {...props} />,
  },
  {
    path:"/care-intro",
    render:(props) => <Gatekeeper {...props}><CareAdminIntro {...props}/></Gatekeeper>
  },
  {
    path:"/begin-assessment",
    render:(props)=><BeginAssessment {...props}/>
  },
  {
    path:"/appointment-details",
    render:(props)=><AppointmentConfirmation {...props}/>
  },
    {
    path:"/memcheck",
    render:(props)=><MemCheck {...props}/>
  },
  {
    path: "/privacy",
    render: (props) => <PrivacyPolicyPage {...props} />,
  },
  {
    path: "/terms",
    render: (props) => <TermsPage {...props} />,
  },
];
export const LoggedUserRoutesB2C=[];
export const SettingsRoutesCase1 = [
  {
  path: "/my-account",
      label: "My Profile",
      value: "my-account",
      icon: <ProfileMenu />,
      render: (props) => <MyProfile {...props} />,
  showmenu: true,
   },

    {
      path: "/profile-lists",
      label: "Switch Account",
      value: "profile-lists",
      render: (props) => <AccountProfiles {...props} />,
    },
    {
    path: "/privacy",
    render: (props) => <PrivacyPolicyPage {...props} />,
  },
  {
    path: "/terms",
    render: (props) => <TermsPage {...props} />,
  },
   
 
]
export const SettingsRoutesCase2 = [
  {
  path: "/my-account-child",
      label: "My Profile",
      value: "my-account-child",
      icon: <ProfileMenu />,
      render: (props) => <MyProfileChild {...props} />,
  showmenu: true,
   },

    {
      path: "/profile-lists",
      label: "Switch Account",
      value: "profile-lists",
      render: (props) => <AccountProfiles {...props} />,
    },
]
export const SettingsDoctorRoutes = [
  {
  path: "/my-account",
      label: "My Profile",
      value: "my-account",
      icon: <ProfileMenu />,
      render: (props) => <MyProfile {...props} />,
  showmenu: true,
   },

    {
      path: "/profile-lists",
      label: "Switch Account",
      value: "profile-lists",
      render: (props) => <AccountProfiles {...props} />,
    },
]
export const LogoutRoutes = [{
  path: "/Settings",
  label:"Settings",
  value:"settings",
  icon: <SettingsMenu />,
  showmenu: true,
  children: [
    {
      key:"logout",
      label:"Logout",
      value:"logout"
    }
  ],
  },
]

export const SupervisingDoctorsRoutes = [
  {
    path: "/add-medicine",
    icon: <AddMedicine/> ,
    showmenu: true,
    label: "Medicines",
    value: "add-medicine",
    render: (props) => <MedicineList {...props} from="care-admin" />,
  },
  {
    path: "/reports",
    // icon: <AnalysticsIcon/> ,
    icon: <ReportsIcon/> ,
    showmenu: true,
    label: "Reports",
    value: "analytics",
    render: (props) => <AnalyticsIframe {...props} />,
  },
]

export const DoctorRoutes = [
  {
    path: "/dashboard",
    icon: <DashboardMenu />,
    showmenu: true,
    label: "Dashboard",
    value: "dashboard",
    render: (props) => <Dashboard {...props} />,
  },
  {
    path: "/appointments",
    icon: <ConsultationsCareadmin />,
    showmenu: true,
    label: "Consultations",
    value: "appointments",
    render: (props) => <MyAppointment {...props} />,
  },
  {
    path: "/my-availability",
    icon: <MyAvailabilityIcon/> ,
    showmenu: true,
    label: "My Availability",
    value: "my-availabilities",
    children: [
      {
        path: "/my-availability",
        label: "My Availability",
        value: "my-availability",        
        render: (props) => <MyAvailability {...props} />,
      },
      {
        path: "/my-availability-new-version",
        label: "My Availability (Beta Version)",
        value: "my-availability-new-version",
        render: (props) => <MyAvailabilityNewVersion {...props} />,
      }
    ],
  },
  {
    path: "/all-patients",
    icon: <MyPatientIcon/>,
    label: "Patients",
    value: "all-patients",
    showmenu: true,
    render: (props) => <MyAllPatient {...props} />,
  },
  {
    path: "/instructions",
    // icon: <HealthProfileMenu/>,
    icon: <InstructionsMenu/>,
    label: "Instructions",
    value: "instructions",
    showmenu: true,
    render: (props) => <DoctorFollowUpTickets {...props} />,
  },
  {
    path: "/my-account",
    icon: <MyProfileIcon />,
    showMenu: false,
    children: [
      {
        path: "/my-account",
        label: "My Profile",
        value: "my-account",
        render: (props) => <MyProfile {...props} />,
      },
    ],
  },
  {
    path: "/video-consultation",
    render: (props) => (<VideoConsultation {...props} />),
  },
  {
    path: "/assessment-history",
    render: (props) => <AssessmentHistory {...props} />,
  },
  {
    path: "/health-profile",
    render: (props) => <PHISummary {...props} />,
  },
  {
    path: "/document-upload",
    render: (props) => <MedicalDocument {...props} />,
  },
  {
    path: "/patient-detail",
    render: (props) => <PatientDetail {...props} />,
  },
  {
    path: "/my-patientsdetails", 
    render: (props) => <MyPatientDetail {...props} />,
  }
];

export const CareAdminRoutes = [
  // {
  //   path: "/select-tickets",
  //   icon: <MyTicketIcon/> ,
  //   showmenu: true,
  //   label: "My Tickets",
  //   value: "select-tickets",
  //   render: (props) => <CareAdmin {...props} />,
  // },
  {
    path: "/tickets-list",
    icon: <AllTicketIcon/>,
    showmenu: true,
    label: "All Tickets",
    value: "tickets-list",
    render: (props) => <TicketList {...props} />,
  },
  {
    path: "/search-patient",
    icon: <PatientRecordIcon/> ,
    showmenu: true,
    label: "Patients",
    value: "search-patient",
    render: (props) => <SearchPatient {...props} />,
  },
  // {
  //   path: "/patient-plan",
  //   icon: <PatientRecordIcon/> ,
  //   showmenu: true,
  //   label: "Patient Records",
  //   value: "patient-plan",
  //   render: (props) => <PlanWise {...props} />,
  // },
  {
    path: "/add-medicine",
    icon: <AddMedicine/> ,
    showmenu: true,
    label: "Medicines",
    value: "add-medicine",
    // render: (props) => <FormAddMedicine {...props} from="care-admin" />,
    render: (props) => <MedicineList {...props} from="care-admin" />,
  },
  {
    path: "/manage-coupon",
    icon: <CouponMenuGray/> ,
    showmenu: true,
    label: "Coupons",
    value: "manage-coupon",
    // render: (props) => <FormAddMedicine {...props} from="care-admin" />,
    render: (props) => <ManageCoupon {...props} from="care-admin" />,
  },
  {
    path: "/consultation-list",
    // icon: <AppointmentMenu /> ,
    icon: <ConsultationsCareadmin /> ,
    showmenu: true,
    label: "Consultations",
    value: "consultation-list",
    render: (props) => <ConsultationList {...props} />,
  },
  {
    path: "/doctor-availabilty",
    // icon: <ConsultationIcon/> ,
    icon: <CareadminDoctors/> ,
    showmenu: true,
    label: "Doctors",
    value: "doctor-availabilty",
    render: (props) => <MyAvailabilityNewVersion {...props} />,
  },
  {
    path: "/org-records",
    // icon: <MyPatientIcon/> ,
    icon: <CareadminRecords/> ,
    showmenu: true,
    label: "B2B Records",
    value: "org-records",
    render: (props) => <B2BRecords {...props} />,
  },
  {
    path: "/analytics",
    icon: <AnalysticsIcon/> ,
    showmenu: true,
    label: "Analytics",
    value: "analytics",
    render: (props) => <AnalyticsIframe {...props} />,
  },
  {
    path: "/chat",
    icon: icons.patient_records,
    showmenu: false,
    label: "Chat",
    value: "chat",
    render: (props) => <CareChatPage {...props} />,
  },
  {
    path: "/patient-lists",
    render: (props) => <PatientLists {...props} />,
  },
  {
    path:"/plan-history",
    render: (props)=> <PlanHistory {...props}/>,
  },
  {
    path: "/patient-plan",
    render: (props) => <PlanWise {...props} />,
  },
  {
    path: "/my-tickets",
    render: (props) => <MyTickets {...props} />,
  },
  {
    path: "/patient-records",
    render: (props) => <PatientRecord {...props} />,
  },
  {
    path: "/care-admin-domain",
    render: (props) => <CareAdminDomainDashboard {...props} />,
  },
  {
    path: "/patient-consultation",
    render: (props) => <PatientConsultation {...props} />,
  },
];
export const CareAdminDomainRoutes= [{
  path: "/care-admin-domain",
  render: (props) => <CareAdminDomainDashboard {...props} />
}]
export const ROLE_ROUTES= [{
  path: "/select-role",
  render: (props) => <RoleSelection {...props} />
}]

export const GuestUserRoutes = [
  {
    path: "/dashboard",
    render: (props) => <Landing {...props} />,
  },
  {
    path: "/take-assessment",
    render: (props) => <Assessment {...props} />,
  },
  {
    path: "/assessment-completion",
    render: (props) => <GuestUserAuth {...props} />,
  },
  {
    path: "/getPersonalised", // old landing page: always send to login (keeps any query params)
    render: (props) => <Redirect to={{ pathname: "/guest-user/login", search: props.location.search }} />,
  },
  {
    path: "/switch-account",
    render: (props) => <SwitchAccount {...props} />,
  },
  {
    path: "/privacy-policy",
    target: "_blank",
    render: (props) => <PrivacyPolicy {...props} />,
  },
  {
    path: "/terms-of-use",
    target: "_blank",
    render: (props) => <TermsofUse {...props} />,
  },
  {
    path: "/funneling-questions",
    render: (props) => <FunnelingQuestions {...props} />,
  },
  {
    path: "/assessment",
    render: (props) => <NewSelectAssessmentType {...props} />,
  },
  {
    path:"/login",
    render:(props) => <Login {...props}/>
  },
  {
    path:"/getStarted",
    render:(props) => <Gatekeeper><GetStarted {...props}/></Gatekeeper> 
  },
  {
    path:"/ageCheck",
    render:(props)=><GenderSignUpCheck {...props}/>
  },
  {
    path:"/ageRestriction",
    render:(props)=><AgeRestriction {...props}/>
  },
  {
    path:"/sign-up", // sign-up is disabled for UAE: always send to login (keeps any query params)
    render:(props)=><Redirect to={{ pathname: "/guest-user/login", search: props.location.search }} />
  },
  {
    path:"/forgot-password",
    render:(props) => <ForgotPassword {...props}/>
  },
  {path:"/check-otp",
    render:(props) =><Gatekeeper><OTPInput {...props} /></Gatekeeper> 
  },
  {
    path:"/create-account",
    render:(props) => <SignUpPage {...props}/>
  },
  {
    path:"/B2B-verification",
    render:(props) => <Gatekeeper><B2bFirstLogin {...props}/></Gatekeeper> 
  },
  {
    path:"/First-time-login",
    render:(props)=> <FirstTimeLogin {...props}/>
  },
  {
    path:"/set-password",
    render:(props)=> <SetPasswardScreen {...props}/>
  },
  {
    path:"/recover-account",
    render:(props)=> <OTPDeleteInput {...props}/>
  },
  {
    path:"/begin-assessment",
    render:(props)=><BeginAssessment {...props}/>
  },
      {
    path:"/memcheck",
    render:(props)=><MemCheck {...props}/>
  },
  {
    path:"/self-assessment",
    render:(props)=><DynamicLinking {...props}/>
  },
  {
    path: "/ziloy-sign-up",
    render: (props) => <DementiaAssessmentLinking {...props} />,
  },
];

export const SubscriptionPlanRoutes = [
  {
    path: "/subscription-plan",
    icon: <SubscriptionPlan />,
    showmenu: true,
    label: "Care Plan",
    value: "subscription-plan",
    render: (props) => <Subscription {...props} />,
  },  
  {
    path: "/my-order",
    icon: <MyOrderIcon />,
    showmenu: true,
    label: "Order History",
    value: "my-order",
    render: (props) => <MyOrders {...props} />,
  },
  {
    path: "/coupon-apply",
    render: (props) => <Coupon {...props} />,
  }
];

export const SuperAdminRoutes = [
  {
    path: "/create-role",
    icon: <DashboardMenu />,
    showmenu: true,
    label: "Creat Role",
    value: "create-role",
    render: (props) => <SuperAdmin {...props} />,
  },
  {
    path: "/add-service",
    icon: <HealthProfileMenu />,
    showmenu: true,
    label: "Add Service",
    value: "add-service",
    render: (props) => <AddService {...props} />,
  },
]
export const CorperateAdminRoutes = [
  {
    path: "/dashboard",
    icon: <DashboardMenu />,
    showmenu: true,
    label: "Dashboard",
    value: "dashboard",
    // render: (props) => <CorporateDashboard {...props} />,
    render: (props) => <CorporateDashboardNew {...props} />,
  },
  
  //  {
  //   path: "/dashboard",
  //   icon: <DashboardMenu />,
  //   showmenu: true,
  //   label: "Dashboard",
  //   value: "dashboard",
  //   render: (props) => <CorporateDashboardDummy {...props} />,
  // },

  // {
  //   path: "/table",
  //   // icon: <MyPatientIcon/>,
  //   icon: <CareadminRecords/>,
  //   showmenu: true,
  //   label: "Records",
  //   value: "table",
  //   render: (props) => <CorporateTable {...props} />,
  // },

  //  {
  //   path: "/table",
  //   // icon: <MyPatientIcon/>,
  //   icon: <CareadminRecords/>,
  //   showmenu: true,
  //   label: "Records",
  //   value: "table",
  //   render: (props) => <CorporateTableDummy {...props} />,
  // },
    {
    path: "/corporate-person-info",
    render: (props) => <CorporatePersonInfo {...props} />,
  },


  // {
  //   path: "/Upload",
  //   icon: <img src={icons.new_corporate_admin_upload} />,
  //   showmenu: true,
  //   children: [
  //     {
  //       path: "/uplaod-data",
  //       label: "Create Account",
  //       value: "upload_data",
  //       render: (props) => <UploadFile {...props} />,
  //     },
  //   ],
  // },
]
